<template>
  <div class="page-container">
    <div class="flex-between top">
      <div>

      </div>
      <div class="top-icons">
        <img :src="logo" alt="logo" @click="goback">
        <el-popover placement="top-start" width="200" trigger="hover">
          <div class="flex-column-space-between">
            <p class="password cp" @click="changePassword">修改密码<i class="el-icon-caret-right"></i></p>
            <p class="password cp"  style="margin-top: 20px;" @click="changeInfor">编辑资料<i class="el-icon-caret-right"></i></p>
            <p class="password cp" @click="quit" style="margin-top: 20px;">退出登录<i class="el-icon-caret-right"></i></p>
          </div>
          <img :src="av" alt="头像" slot="reference">
        </el-popover>
      </div>
    </div>
    
    <div class="flex-between top2">
      <h2 class="motto">笃学力行 守正求新</h2>

    </div>
    
    <div class="main-content">
      <div class="mainbox">
        <div class="left-section" v-loading="loading2">
          <div class="box1left1">
            <p class="text">辅导员</p>
            <p class="teaname">{{ mycounsellor }}</p>
            <p class="includuce">{{myuserDepartment}}辅导员，联系电话：{{ myphone }}</p>
          </div>
          <div class="box1left2">
             <p class="text">帮扶老师</p>
             <p class="teaname">{{ details.teacherName }}</p>
            <div class="classes">
             <p class="se">帮扶课程：{{ details.courseName }}</p>
             <p class="se">开课日期：{{ details.courseTime?.split(' ')[0] ?? '--' }}</p>
             <p class="se">目标得分：{{ details.targetScore }}</p>
             <p class="se">当前得分：{{ details.currentScore  }} <span v-if="Number(details.currentScore) < Number(details.targetScore)" style="color: red;">（分数不足）</span></p>
             <p class="se">目标时长（min）：{{ details.targetTimeLength }}</p>
             <p class="se">学习时长（min）：{{ details.targetTime }}<span v-if="Number(details.targetTime) < Number(details.targetTimeLength)" style="color: red;">（时长不足）</span></p>
            </div>
          </div>
        </div>
        
        <div class="middle-section">
     <div class="box1center">
  <!-- 固定头部（不滚动） -->
  <div class="flex-between">
    <p class="text">课程列表</p>
    <p v-if="classnum">总计：{{ classnum }}门课</p>
  </div>

  <!-- 可滚动的课程列表部分 -->
  <div class="scrollable-content">
    <div class="courses-wrapper">
      <div class="courses-container"  v-if="lessonLists.length>0">
        <div 
          class="course-item"
          v-for="(item, index) in lessonLists"
          :key="index"
         @click="tapclass(item.courseId)"
        >
          <p class="course-text">课程名称：{{ item.courseName }}</p>
          <p class="course-text">学习总时长（min）：{{ item.totalDuration }}</p>
          <p class="course-text">总得分：{{ item.totalScore}}</p>
          <p class="course-text">开课时间：{{ item.startTime}}</p>
          <p class="course-text">截止时间：{{ item.endTime }}</p>
        </div>

      </div>
      <div class="courses-container" v-else >
          <p style="margin: 0 auto; font-size: 28px;display: flex;justify-content: center;">暂时没有课程</p>
      </div>
    </div>
  </div>
</div>
          <div  class="box2center">
            <div class="flex-between">
                <p class="text">课程学习情况</p>
                <p>{{className}}</p>
            </div>
            <div>
              <el-table
            :data="bottomList"
             height="41vh"
             style="font-size: 20px;"
            :default-sort = "{prop: 'date', order: 'descending'}"
            >
           
            <el-table-column prop="curriculumName" label="小结名称"  header-align="center" align="center"></el-table-column>

            <el-table-column
              label="视频预览"
              header-align="center" align="center"
              >  
              <template slot-scope="scope">              
                   <img :src="video" alt="" @click="watchVideo(scope.row)">
              </template>
            </el-table-column>
            <el-table-column prop="targetDurationStr" label="学习时长（min）" header-align="center" align="center"></el-table-column>
            <el-table-column prop="totalMark" label="作业总分" header-align="center" align="center"></el-table-column>
             <el-table-column prop="homeworkMark" label="作业得分" header-align="center" align="center"></el-table-column>
            <el-table-column   
              label="作业详情"
              header-align="center" align="center"
              >
              <template slot-scope="scope">          
                    <el-button size="small" class="notsub" v-if="scope.row.isPaper == 0" @click="goSubmit(scope.row)" >未提交</el-button>

                    <el-button size="small" class="detail" v-if="scope.row.isPaper == 2" @click="goDetail(scope.row)">查看详情</el-button>
                    <el-button size="small" class="grading" v-if="scope.row.isPaper == 1" @click="correcting">批改中</el-button>
                    <!-- <el-button size="small" class="detail"  @click="goDetail(scope.row)">未提交</el-button> -->
              </template>
            </el-table-column>
          </el-table>
            </div>
          </div>
        </div>
        <div class="right-section" >
          <div @click="check">
            <img :src="send" alt="" style="width: 100%;height: 15vh;" >
          </div>
    <div class="rightbottom" >
    <div class="flex-between">
      <p class="text">最新作业成绩</p>
      <p class="rednum" v-if="sum">{{ sum }}</p>
    </div>
    <div class="homework-container-wrapper">
      <div class="homework-container" v-if="vo.length > 0">
        <div 
          class="over1"
          v-for="(item, index) in vo"
          :key="index"
        >
          <div class="homework-item">
            <div class="homework-indicator"></div>
            <div class="homework-info">
              <p class="les">{{ item.curriculumName }}</p>
              <p class="sse">{{ item.userName }}</p>
            </div>
            <div class="homework-meta">
              <p class="pigai">{{ item.lastUpdateTime }}</p>
              <div class="view-icon"
                >
                <img

                :src="teamicon" 
                alt="查看作业" 
                 style="width: 35px; height: 35px;" 
                 @click="turnOpen(item)"
              >
              </div>
      
            </div>
          </div>
        </div>
      </div>
      <div v-else>
          <p style="margin: 0 auto; font-size: 20px;display: flex;justify-content: center;">暂时没有作业</p>
      </div>
    </div>
  </div>
        
        </div>
      </div>
    </div>
          <div v-show="showDialogs" class="overlay" @click="showDialogs = false" ></div>
      
      <div v-show="showDialogs" class="dialog left-dialog" >
        <p class="stusname">申请课程</p>
        <div class="flex-between score-info">
          <p class="stusname">选中需要帮扶的课程</p>
        </div>
        <div class="flex-column-between" style="justify-content: space-between;height: 87%;">
              <div>
                 <el-select v-model="classList" placeholder="请选择" style="width: 100%;">
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.label"
                  :value="item">
                </el-option>
              </el-select>
              </div>
              <div class="surebox">
                <p class="texttitles">*点击确定既为发送申请</p>
                <el-button type="primary" class="sure" :loading="loading1" @click="ascertain">确定</el-button>
              </div>
        </div>
        

      </div>
        <el-dialog 
    :visible.sync="dialogVisible2" 
    width="95%" 
    title="视频观看" 
    custom-class="custom-dialog" 
    @close="closeclear"
    top="1vh"
  >
    <!-- 视频播放器 -->
    <div class="video-container">
      <video 
        v-if="videoUrl" 
        ref="videoPlayer" 
        :src="videoUrl" 
         controlsList="nodownload nofullscreen" 
        controls 
        class="fixed-video"
      ></video>
      <p v-else>播放出错</p>
    </div>
      <!-- 滑块验证对话框 -->
<el-dialog
  title="安全验证"
  :visible.sync="showSliderVerify"
  width="420px"
  append-to-body
  :close-on-click-modal="false"
  :show-close="false"
  custom-class="verify-dialog"
>
  <div class="verify-container">
    <div class="verify-header">
      <i class="el-icon-warning-outline"></i>
      <h3>请完成安全验证</h3>
      <p class="verify-tip">拖动滑块完成验证</p>
    </div>
    
    <div class="verify-body">
      <el-slider
        v-model="sliderValue"
        :format-tooltip="formatSliderTooltip"
        @change="handleSliderVerify"
        :step="1"
        height="6px"
      >
        <template #button>
          <div class="slider-button">
            <i class="el-icon-right" :style="{transform: `rotate(${sliderValue * 1.8}deg)`}"></i>
          </div>
        </template>
      </el-slider>
      
      <div class="slider-track">
        <div 
          class="slider-progress" 
          :style="{width: `${sliderValue}%`}"
        ></div>
      </div>
      
      <p class="verify-hint" v-if="sliderValue < 90">
        请向右拖动滑块验证
      </p>
      <p class="verify-success" v-else>
        <i class="el-icon-success"></i> 验证通过
      </p>
    </div>
  </div>
</el-dialog>
  </el-dialog>
      <div v-show="showDialogs" class="dialog1 right-dialog">
        <span class="close-icon" @click="showDialogs = false">×</span>
             <el-table
                :data="classData"
                height="91%"
                style="width: 100%;margin-top: 50px;"
                :default-sort = "{prop: 'date', order: 'descending'}"
              >
                <el-table-column prop="courseName" label="课程名称" fixed header-align="center" align="center"></el-table-column>
                <el-table-column prop="updateName" label="辅导员" header-align="center" align="center"></el-table-column>
                <el-table-column prop="counselorName" label="带教老师" header-align="center" align="center"></el-table-column>
                <el-table-column prop="createTime" label="申请时间" header-align="center" align="center"></el-table-column>
               
                <el-table-column  label="申请情况" header-align="center" align="center">
                  <template slot-scope="scope">
                    <el-button size="small" class="shenhe" v-if="scope.row.reqType ==  '0'">待审核</el-button>
                    <el-button size="small" class="bohui" v-if="scope.row.reqType ==  '1'">被驳回</el-button>
                    <el-button size="small" class="tongguo"  v-if="scope.row.reqType ==  '2'">已通过</el-button>
                  </template>
                </el-table-column>
              </el-table>
      </div>
    <el-dialog :visible.sync="dialogVisible" width="25%" custom-class="custom-dialog">
      <Password @custom-event="handleDataFromChild2"></Password>
    </el-dialog>
    
    <el-dialog :visible.sync="dialogVisible1" width="25%" custom-class="custom-dialog">
      <Information @custom-info="handleDataFromInfo2" :inform = "inform"></Information>
    </el-dialog>
       <!-- 遮罩层 -->
    <div 
      v-show="showDialogs1" 
      class="overlay"
      @click="showDialogs1 = false"
    ></div>
        <!-- 左侧对话框 -->
    <div v-show="showDialogs1" class="dialog2 left-dialog2">
      <p class="stusname">小结名称：{{ curriculumName }}</p>
      <div class="flex-between" style="margin-bottom: 23px;">
        <p class="stusname">卷面总分：{{ totalMark }}</p>
        <p class="stusname">及格线<span>{{ passMark }}</span></p>
      </div>
            <div>
        <div class="flex-between titlebg"  
        :class="{ 'active-type': activeQuestionType === 'single' }" 
    @click="activeQuestionType = 'single'">
            <p>一、单选题</p>        
            <p ><span style="margin:  auto 0;">{{singlescore}}分/题</span></p> 
        </div>
           <AddnewChoose 
                ref="addNewChoose"
                :count="forms.length"
                :active-box="currentFormIndex + 1"
                @switch-form="switchForm"
                :show="show"
            />
  
          <div class="flex-between titlebg"   :class="{ 'active-type': activeQuestionType === 'multiple' }"
  @click="activeQuestionType = 'multiple'" >
            <p>二、多选题</p>
             <p > <span style="margin:  auto 0;">{{multiplescore}}分/题</span></p>
          </div>
            <AddnewmoreChoose 
                ref="addNewChoose1"
                :count="forms1.length"
                :active-box="currentFormIndex1 + 1"                
                @switch-form="switchForm1"
                :show="show"
            />
          <div class="flex-between titlebg"    :class="{ 'active-type': activeQuestionType === 'judge' }"
  @click="activeQuestionType = 'judge'">
            <p>三、判断题</p>
             <p ><span style="margin:  auto 0;">{{judgmentscore}}分/题</span></p>
          </div>
          
            <AddnewJudgment 
                ref="addNewChoose2"
                :count="forms2.length"
                :active-box="currentFormIndex2 + 1"
                @switch-form="switchForm2"
                :show="show"
            />
        <div class="flex-between titlebg" 
          :class="{ 'active-type': activeQuestionType === 'subjective' }"
  @click="activeQuestionType = 'subjective'"
        >
            <p>四、主观题</p>
            
             <p > <span style="margin:  auto 0;">{{subjectivescore}}分/题</span></p>
          </div>
          
                  <AddnewSubjective
                ref="addNewChoose3"
                :count="forms3.length"
                :active-box="currentFormIndex3 + 1"
                
                @switch-form="switchForm3"
                :show="show"
            />

          
      </div>
      <el-button type="primary" style="margin-top: 50px;height: 40px;" @click="submithomework">提交作业<i class="el-icon-upload el-icon--right"></i></el-button>
    </div>


      <!-- 右侧对话框 -->
<div v-show="showDialogs1" class="dialog3 right-dialog2" style="padding-right: 60px">
  <span class="close-icon" @click="showDialogs1 = false">×</span>
    <div v-if="activeQuestionType === 'single'">
          <h2>单选题</h2>
      <!-- 所有题目容器（垂直排列） -->
  <div class="questions-container">
    <!-- 动态渲染每个题目表单 -->
    <div 
      v-for="(form, index) in forms" 
      :key="index" 
      class="current-question single-question"
      :class="{ 'active-form': currentFormIndex === index }"
    >
      <el-form :model="form" label-width="80px">
        <!-- 题目 -->
        <el-form-item :label="'题目' + form.sort + '：'">
          <div style="display: flex; justify-content: space-between;">
            <!-- <el-input v-model="form.question" placeholder="请输入题目" style="position: relative;"></el-input> -->
             <span>{{ form.question}}</span>
          </div>
        </el-form-item>
        <!-- 回显题目 -->
            <el-image
      style="width: 100%; max-height: 600px; object-fit: contain;"
      :src="form.questionPictureVo?.downloadUrl"
          :preview-src-list="form.questionPictureVo?.downloadUrl ? [form.questionPictureVo.downloadUrl] : []"
       v-if="form.questionPictureVo?.downloadUrl"
      ></el-image>

        <!-- 答案输入框 -->
        <el-row :gutter="40">
          <el-col v-for="(answer, aIndex) in form.answers" :key="aIndex" :span="12"  style="margin-bottom: 20px;">
            <el-form-item :label="answer.label+'：'">
              <!-- <span>{{ answer.value }}</span> -->
              <el-input v-model="answer.value" :placeholder="answer.label" style="position: relative;" :disabled="true"></el-input>
              <div 
                @click="toggleCheck(index, aIndex)" 
                :class="{'checked': answer.checked}" 
                class="check-box"
              >
                <span v-if="answer.checked">✓</span>
              </div>
  
            </el-form-item>
          </el-col>
        </el-row>


      </el-form>
    </div>
  </div>


    </div>
   
<!-- 多选题 -->
<div v-if="activeQuestionType === 'multiple'">
    <h2>多选题</h2>
          <!-- 所有题目容器（垂直排列） -->
  <div class="questions-container">
    <!-- 动态渲染每个题目表单 -->
    <div 
      v-for="(form, index) in forms1" 
      :key="index" 
      class="current-question multiple-question"
      :class="{ 'active-form': currentFormIndex1 === index }"
    >
      <el-form :model="form" label-width="80px">
        <!-- 题目 -->
        <el-form-item :label="'题目' + form.sort + '：'">
          <div style="display: flex; justify-content: space-between;">
            <!-- <el-input v-model="form.question" placeholder="请输入题目" style="position: relative;"></el-input> -->
             <span>{{ form.question}}</span>
          </div>
        </el-form-item>
                <!-- 回显题目 -->
            <el-image
      style="width: 100%; max-height: 600px; object-fit: contain;"
      :src="form.questionPictureVo?.downloadUrl"
          :preview-src-list="form.questionPictureVo?.downloadUrl ? [form.questionPictureVo.downloadUrl] : []"
       v-if="form.questionPictureVo?.downloadUrl"
      ></el-image>

        <!-- 答案输入框 -->
        <el-row :gutter="40">
          <el-col v-for="(answer, aIndex) in form.answers" :key="aIndex" :span="12"  style="margin-bottom: 20px;">
            <el-form-item :label="answer.label+'：'">
              <el-input v-model="answer.value" :placeholder="answer.label" style="position: relative;" :disabled="true"></el-input>
              <div 
                @click="toggleCheck1(index, aIndex)" 
                :class="{'checked': answer.checked}" 
                class="check-box"
              >
                <span v-if="answer.checked">✓</span>
              </div>
   
            </el-form-item>
          </el-col>
        </el-row>

    
      </el-form>
    </div>


</div>
    </div>
      <!-- 判断题 -->
<div v-if="activeQuestionType === 'judge' ">
    <h2>判断题</h2>
            <!-- 所有题目容器（垂直排列） -->
  <div class="questions-container">
    <!-- 动态渲染每个题目表单 -->
    <div 
      v-for="(form, index) in forms2" 
      :key="index" 
      class="current-question judge-question"
      :class="{ 'active-form': currentFormIndex2 === index }"
    >
      <el-form :model="form" label-width="80px">
        <!-- 题目 -->
        <el-form-item :label="'题目' + form.sort + '：'">
          <div style="display: flex; justify-content: space-between;">
            <!-- <el-input v-model="form.question" placeholder="请输入题目" style="position: relative;"></el-input> -->
            <span>{{ form.question}}</span>
          </div>
        </el-form-item>
        <!-- 回显题目 -->
            <el-image
      style="width: 100%; max-height: 600px; object-fit: contain;"
      :src="form.questionPictureVo?.downloadUrl"
          :preview-src-list="form.questionPictureVo?.downloadUrl ? [form.questionPictureVo.downloadUrl] : []"
       v-if="form.questionPictureVo?.downloadUrl"
      ></el-image>
        <!-- 答案输入框 -->
        <el-row :gutter="40">
          <el-col v-for="(answer, aIndex) in form.answers" :key="aIndex" :span="12"  style="margin-bottom: 20px;">
            <el-form-item :label="answer.label+'：'">
              <el-input v-model="answer.value" :placeholder="answer.label"  :disabled="true" style="position: relative;" ></el-input>
              <div 
                @click="toggleCheck2(index, aIndex)" 
                :class="{'checked': answer.checked}" 
                class="check-box"
              >
                <span v-if="answer.checked">✓</span>
              </div>
    
            </el-form-item>
          </el-col>
        </el-row>


      </el-form>
    </div>
  </div>

</div>
    <!-- 主观题 -->
<div v-if="activeQuestionType === 'subjective' ">
    <h2>主观题</h2>

      <!-- 所有题目容器（垂直排列） -->
  <div class="questions-container">
    <!-- 动态渲染每个题目表单 -->
    <div 
      v-for="(form, index) in forms3" 
      :key="index" 
      class="current-question subjective-question"
      :class="{ 'active-form': currentFormIndex3 === index }"
    >
      <el-form :model="form" label-width="80px">
        <!-- 题目 -->
         <span >题目{{form.sort}}：{{ form.question }}</span>
                        <!-- 回显题目 -->
            <el-image
      style="width: 100%; max-height: 600px; object-fit: contain;"
      :src="form.questionPictureVo?.downloadUrl"
          :preview-src-list="form.questionPictureVo?.downloadUrl ? [form.questionPictureVo.downloadUrl] : []"
       v-if="form.questionPictureVo?.downloadUrl"
      ></el-image>
    <el-divider></el-divider>

        <el-form-item label="答：" style="margin-top: 40px;">
            <div class="image-actions" 
            v-if="form.answerImageUrl">
             <!-- 显示已上传的答案图片 -->
          <el-image 
            style="width: 100%; max-height: 400px; object-fit: contain; margin-bottom: 20px;"
            :src="form.answerImageUrl"
            :preview-src-list="[form.answerImageUrl]"
            fit="cover"
          ></el-image>
                  

        <el-button 
              size="small" 
              icon="el-icon-delete" 
              type="danger" 
              @click="handleRemove1(index)">
              删除
            </el-button>
        </div>
          
          <!-- 上传答案图片的按钮（只在没有图片时显示） -->
          <el-upload
            v-if="!form.answerImageUrl"
            :action="uploadpica"
            list-type="picture-card"
            :on-success="(response, file) => handleSuccess1(response, file, index)"
            :before-upload="beforeUpload"
            :show-file-list="false"
            class="custom-upload"
          >
            <i class="el-icon-plus"></i>
          </el-upload>



          <div style="display: flex; justify-content: space-between;margin-top: 40px;">
            <textarea v-model="form.answer" placeholder="请输入内容..." style="position: relative;width: 100%;height: 100px;padding: 10px 20px 10px 10px;"></textarea>
          </div>
        </el-form-item>
 
 


      </el-form>
    </div>
  </div>

</div>



  </div>






<!-- 最终试卷 -->
          <!-- 遮罩层 -->
    <div 
      v-show="showDialogs2" 
      class="overlay"
      @click="close222"
    ></div>
                <!-- 左侧对话框 -->
    <div v-show="showDialogs2" class="dialog2 left-dialog2">
      <div class="flex-between">
        <p class="stusname">小结名称：{{ curriculumName }}</p>
        <el-button type="danger" @click="reset"  style="width: 80px;">重做</el-button>
      </div>
      
      <div class="flex-between" style="margin-bottom: 23px;">
        <p class="stusname">卷面总分/及格线：{{ totalMark }}/{{ passMark }}</p>
              <p class="stusname">
  成绩： 
  <span :style="{ color: scoreCount < passMark ? 'red' : 'black' }">
    {{ scoreCount }}
  </span>
</p>
      </div>
            <div>
        <div class="flex-between titlebg"  
        :class="{ 'active-type': activeQuestionType === 'single' }" 
    @click="activeQuestionType = 'single'">
            <p>一、单选题</p>        
            <p ><span style="margin:  auto 0;">得分：{{ oneCount }}</span></p> 
        </div>
           <AddnewChoose 
                ref="addNewChoose"
                :count="forms.length"
                :active-box="currentFormIndex9 + 1"
                @switch-form="switchForm9"
                :show="show"
                :error-questions="errorQuestions"
            />
  
          <div class="flex-between titlebg"   :class="{ 'active-type': activeQuestionType === 'multiple' }"
  @click="activeQuestionType = 'multiple'" >
            <p>二、多选题</p>
             <p > <span style="margin:  auto 0;">得分：{{ twoCount }}</span></p>
          </div>
            <AddnewmoreChoose 
                ref="addNewChoose1"
                :count="forms1.length"
                :active-box="currentFormIndex8 + 1"                
                @switch-form="switchForm8"
                :show="show"
                :error-questionss="errorQuestionss"
            />
          <div class="flex-between titlebg"    :class="{ 'active-type': activeQuestionType === 'judge' }"
  @click="activeQuestionType = 'judge'">
            <p>三、判断题</p>
             <p ><span style="margin:  auto 0;">得分：{{ threeCount }}</span></p>
          </div>
          
            <AddnewJudgment 
                ref="addNewChoose2"
                :count="forms2.length"
                :active-box="currentFormIndex7 + 1"
                @switch-form="switchForm7"
                :show="show"
                :error-questionsss="errorQuestionsss"
            />
        <div class="flex-between titlebg" 
          :class="{ 'active-type': activeQuestionType === 'subjective' }"
  @click="activeQuestionType = 'subjective'"
        >
            <p>四、主观题</p>
            
             <p > <span style="margin:  auto 0;">得分：{{ fourCount }}</span></p>
          </div>
          
                  <AddnewSubjective
                ref="addNewChoose3"
                :count="forms3.length"
                :active-box="currentFormIndex6 + 1"
                
                @switch-form="switchForm6"
                :show="show"
            />

          
      </div>

    </div>
                  <!-- 右侧对话框 -->
<div v-show="showDialogs2" class="dialog3 right-dialog2" style="padding-right: 60px">
  <span class="close-icon" @click="close222">×</span>
    <div v-if="activeQuestionType === 'single'">
          <h2>单选题</h2>
      <!-- 所有题目容器（垂直排列） -->
  <div class="questions-container">
    <!-- 动态渲染每个题目表单 -->
    <div 
      v-for="(form, index) in forms" 
      :key="index" 
      class="current-question single-question"
      :class="{ 'active-form': currentFormIndex9 === index }"
    >
      <el-form :model="form" label-width="80px">
        <!-- 题目 -->
        <el-form-item :label="'题目' + form.sort + '：'">
          <div style="display: flex; justify-content: space-between;">
            <!-- <el-input v-model="form.question" placeholder="请输入题目" style="position: relative;"></el-input> -->
             <span>{{ form.question}}</span>
          </div>
        </el-form-item>
                        <!-- 回显题目 -->
            <el-image
      style="width: 100%; max-height: 600px; object-fit: contain;"
      :src="form.questionPictureVo?.downloadUrl"
          :preview-src-list="form.questionPictureVo?.downloadUrl ? [form.questionPictureVo.downloadUrl] : []"
       v-if="form.questionPictureVo?.downloadUrl"
      ></el-image>

        <!-- 答案输入框 -->
        <el-row :gutter="40" >
          <el-col v-for="(answer, aIndex) in form.answers" :key="aIndex" :span="12" style="margin-bottom: 20px;">
            <el-form-item :label="answer.label+'：'">
              <!-- <span>{{ answer.value }}</span> -->
              <el-input v-model="answer.value" :placeholder="answer.label" style="position: relative;" :disabled="true"></el-input>
              <!-- <div 
               
                :class="{'checked': answer.checked}" 
                class="check-box"
                style="pointer-events: none;"
              >
                <span v-if="answer.checked">✓</span>
              </div> -->
  
            </el-form-item>
          </el-col>
        </el-row>
                <div class="stand" v-if="form.answerResult == 1">
          <span style="font-weight: 700;color: #0825e6;">回答正确</span>
        </div>
        <div class="stand"  v-if="form.answerResult == 2">
          <span style="font-weight: 700;color: red;">回答错误</span>
        </div>
        <div class="stand">
          <span style="font-weight: 700;"> 你的答案：</span>{{ form.questionAnswer }}
        </div>


      </el-form>
    </div>
  </div>


    </div>
   
<!-- 多选题 -->
<div v-if="activeQuestionType === 'multiple'">
    <h2>多选题</h2>
          <!-- 所有题目容器（垂直排列） -->
  <div class="questions-container">
    <!-- 动态渲染每个题目表单 -->
    <div 
      v-for="(form, index) in forms1" 
      :key="index" 
      class="current-question multiple-question"
      :class="{ 'active-form': currentFormIndex8 === index }"
    >
      <el-form :model="form" label-width="80px">
        <!-- 题目 -->
        <el-form-item :label="'题目' + form.sort + '：'">
          <div style="display: flex; justify-content: space-between;">
            <!-- <el-input v-model="form.question" placeholder="请输入题目" style="position: relative;"></el-input> -->
             <span>{{ form.question}}</span>
          </div>
        </el-form-item>
                        <!-- 回显题目 -->
            <el-image
      style="width: 100%; max-height: 600px; object-fit: contain;"
      :src="form.questionPictureVo?.downloadUrl"
          :preview-src-list="form.questionPictureVo?.downloadUrl ? [form.questionPictureVo.downloadUrl] : []"
       v-if="form.questionPictureVo?.downloadUrl"
      ></el-image>

        <!-- 答案输入框 -->
        <el-row :gutter="40">
          <el-col v-for="(answer, aIndex) in form.answers" :key="aIndex" :span="12" style="margin-bottom: 20px;">
            <el-form-item :label="answer.label+'：'">
              <el-input v-model="answer.value" :placeholder="answer.label" style="position: relative;" :disabled="true"></el-input>
              <!-- <div 
                
                :class="{'checked': answer.checked}" 
                class="check-box"
                style="pointer-events: none;"
              >
                <span v-if="answer.checked">✓</span>
              </div> -->
   
            </el-form-item>
          </el-col>
        </el-row>
                <div class="stand" v-if="form.answerResult == 1">
          <span style="font-weight: 700;color:#0825e6;">回答正确</span>
        </div>
        <div class="stand"  v-if="form.answerResult == 2">
          <span style="font-weight: 700;color: red;">回答错误</span>
        </div>
          <div class="stand">
          <span style="font-weight: 700;"> 你的答案：</span>{{ form.questionAnswer }}
        </div>

    
      </el-form>
    </div>


</div>
    </div>
      <!-- 判断题 -->
<div v-if="activeQuestionType === 'judge' ">
    <h2>判断题</h2>
            <!-- 所有题目容器（垂直排列） -->
  <div class="questions-container">
    <!-- 动态渲染每个题目表单 -->
    <div 
      v-for="(form, index) in forms2" 
      :key="index" 
      class="current-question judge-question"
      :class="{ 'active-form': currentFormIndex7 === index }"
    >
      <el-form :model="form" label-width="80px">
        <!-- 题目 -->
        <el-form-item :label="'题目' + form.sort + '：'">
          <div style="display: flex; justify-content: space-between;">
            <!-- <el-input v-model="form.question" placeholder="请输入题目" style="position: relative;"></el-input> -->
            <span>{{ form.question}}</span>
          </div>
        </el-form-item>
                <!-- 回显题目 -->
            <el-image
      style="width: 100%; max-height: 600px; object-fit: contain;"
      :src="form.questionPictureVo?.downloadUrl"
          :preview-src-list="form.questionPictureVo?.downloadUrl ? [form.questionPictureVo.downloadUrl] : []"
       v-if="form.questionPictureVo?.downloadUrl"
      ></el-image>
        <!-- 答案输入框 -->
        <el-row :gutter="40">
          <el-col v-for="(answer, aIndex) in form.answers" :key="aIndex" :span="12">
            <el-form-item :label="answer.label+'：'">
              <el-input v-model="answer.value" :placeholder="answer.label"  :disabled="true" style="position: relative;" ></el-input>
              <!-- <div 
                
                :class="{'checked': answer.checked}" 
                class="check-box"
                style="pointer-events: none;"
              >
                <span v-if="answer.checked">✓</span>
              </div> -->
    
            </el-form-item>
          </el-col>
        </el-row>
                <div class="stand" v-if="form.answerResult == 1">
          <span style="font-weight: 700;color: #0825e6;">回答正确</span>
        </div>
        <div class="stand"  v-if="form.answerResult == 2">
          <span style="font-weight: 700;color: red;">回答错误</span>
        </div>
        <div class="stand">
          <span style="font-weight: 700;"> 你的答案：</span>{{ form.questionAnswer }}
        </div>

      </el-form>
    </div>
  </div>

</div>
    <!-- 主观题 -->
<div v-if="activeQuestionType === 'subjective' ">
  <h2>主观题</h2>

  <!-- 所有题目容器（垂直排列） -->
  <div class="questions-container">
    <!-- 动态渲染每个题目表单 -->
    <div 
      v-for="(form, index) in forms3" 
      :key="index" 
      class="current-question subjective-question"
      :class="{ 'active-form': currentFormIndex6 === index }"
    >
      <el-form :model="form" label-width="80px">
        <!-- 题目 -->
         <span >题目{{form.sort}}：{{ form.question }}</span>
                        <!-- 回显题目 -->
            <el-image
      style="width: 100%; max-height: 600px; object-fit: contain;"
      :src="form.questionPictureVo?.downloadUrl"
          :preview-src-list="form.questionPictureVo?.downloadUrl ? [form.questionPictureVo.downloadUrl] : []"
       v-if="form.questionPictureVo?.downloadUrl"
      ></el-image>
          <div class="stand">
         <span style="font-weight: 700;"> 你的答案：</span>{{ form.questionAnswer }}
                                         <!-- 回显答案图片 -->
            <el-image
      style="width: 100%; max-height: 600px; object-fit: contain;"
      :src="form.answerImageUrl"
          :preview-src-list="form.answerImageUrl ? [form.answerImageUrl] : []"
       v-if="form.answerImageUrl"
      ></el-image>
        </div>
        <div class="stand" style="margin-bottom: 50px;">
         <span style="font-weight: 700;color: brown;"> 批卷回复：</span>
         <span>{{ form.answer }}</span>
         <!-- <textarea v-model="form.answer" placeholder="请输入内容..." style="position: relative;width: 100%;height: 300px;margin-top: 10px; padding: 10px 20px 10px 10px;"></textarea> -->
        </div>

        <div class="flex-between">
          <p style="font-weight: 700;font-size: 25px;">总分：{{ form.score }}</p>
          <div>
            <span  style="font-weight: 700;font-size: 25px;color: blue;">本题得分：</span>
            <span style="font-weight: 700;font-size: 25px;color: blue;">{{ form.count  }}</span>
             <!-- <el-input-number v-model="form.initialValue" controls-position="right" @change="handleChange" :min="0" :max="form.score"></el-input-number> -->
          </div>
        </div>
        
      </el-form>
    </div>
  </div>
  



  </div>
  </div>






  
  </div>
</template>

<script>
import Password from '@/components/Password/Password.vue'
import Information from '@/components/Information/Information.vue'
import AddnewChoose from '@/views/Teacher/compontents/AddnewChoose.vue'
import AddnewmoreChoose from '@/views/Teacher/compontents/AddnewmoreChoose.vue'
import AddnewJudgment from '@/views/Teacher/compontents/AddnewJudgment.vue'
import AddnewSubjective from '@/views/Teacher/compontents/AddnewSubjective.vue'
import { goBack } from '@/utils/auto'

export default {
  components: {
    Password,
    Information,
    AddnewChoose,
     AddnewmoreChoose,
     AddnewJudgment,
     AddnewSubjective,


  },
  data() {
    return {
         uploadpica:`${this.$config.API_BASE_URL}/hz-university-pc/file/upload`,
    showSliderVerify: false,  // 是否显示滑块验证
    sliderValue: 0,          // 滑块当前值
    verifyInterval: null,    // 验证定时器
    verifyThreshold: 90,     // 验证通过阈值(90%)
               oneCount:'',
            twoCount:'',
            threeCount:'',
            fourCount:'',
            currentFormIndex9: 0 ,// 当前编辑的题目索引
            currentFormIndex8: 0 ,// 当前编辑的题目索引
            currentFormIndex7: 0 ,// 当前编辑的题目索引
            currentFormIndex6: 0 ,// 当前编辑的题目索引
      showDialogs: false,
      showDialogs1: false,
      showDialogs2: false,
      dialogVisible:false,
      dialogVisible1:false,
      dialogVisible2:false,
      totalMark:'',
      passMark:'',
      curriculumName:'',
      show:1,
       activeQuestionType: 'single', // 默认选中单选题
      mycounsellor: '',
      forms: [],          // 存储所有题目的数组
      forms1:[],
      forms2:[],
      forms3:[],
              form3: {
            question: '',
           image: {
          fileList: [],
          imageUrl: '',
          preview: false
        },
      },
      singlescore:'',
      multiplescore :'',
      judgmentscore :'',
      subjectivescore :'',
      currentFormIndex: 0 ,// 当前编辑的题目索引
      currentFormIndex1: 0 ,// 当前编辑的题目索引
      currentFormIndex2: 0 ,// 当前编辑的题目索引
      currentFormIndex3: 0 ,// 当前编辑的题目索引
      myuserDepartment:'',
      myphone:'',
      teadata:{},
      url: require('@/assets/pic/back.png'),
      logo: require('@/assets/pic/back.png'),
      av: require('@/assets/pic/avatar.png'),
      send: require('@/assets/pic/send.png'),
      teamicon: require('@/assets/pic/teamicon.png'),
      video:require('@/assets/pic/video.png'),
      videoUrl:'',
            // 计时器相关数据
      videoTimer: {
        startTime: null,      // 开始播放时间
        timer: null,          // 计时器实例
        totalSeconds: 0,      // 累计播放秒数
        isPlaying: false      // 是否正在播放
      },
      options: [],
      value: '',
      loading1:false,
      loading2:false,
      classData: [],
      details:{},
      sum:'',
      vo:[],
      videoStats: {
          totalDuration: 0,      // 视频总时长(秒)
          watchedTime: 0,       // 已观看时长(秒)
          intervalId: null,     // 计时器ID
          lastStartTime: 0,     // 最后一次开始播放的时间戳
          isPlaying: false      // 是否正在播放
       },
      loading2:false,
    tableData: [  
    ],
     homeworks: [
      ],
     dialogVisible: false,
     dialogVisible1: false,
     inform:{},
     courseMsgId:'',
     classList:'',
     lessonLists:[],
     classnum:'',
     className:'',
     bottomList:[],
     newhomeworkList:[],
     error:'',
 
    }
  },
  mounted(){
    this.lefttop();
    this.middletop()
    this.rightbotom()
    this.homes()

  },

  watch: {
  dialogVisible2(newVal) {
    if (newVal) {
      this.$nextTick(() => {
        this.setupVideoEventListeners();
      });
    }
  },
      showDialogs2(newVal, oldVal) {
    if (oldVal === true && newVal === false) {
      console.log('1-1-1')
    }
  }
},
      computed: {
        scoreCount() {
  return (Number(this.oneCount) || 0) + (Number(this.twoCount) || 0) + (Number(this.threeCount) || 0) + (Number(this.fourCount) || 0);
},
        // 单选
  errorQuestions() {
  // 获取 forms 和 forms1 中的错误题目索引
  const errorFromForms = this.forms
    .map((form, index) => form.answerResult === 2 ? index + 1 : null)
    .filter(item => item !== null);
  

  return errorFromForms
      
  },
  // 多选
    errorQuestionss() {
  // 获取 forms 和 forms1 中的错误题目索引
  const errorFromForms = this.forms1
    .map((form, index) => form.answerResult === 2 ? index + 1 : null)
    .filter(item => item !== null);
  

  return errorFromForms
      
      
  },
  // 判断
      errorQuestionsss() {

  const errorFromForms = this.forms2
    .map((form, index) => form.answerResult === 2 ? index + 1 : null)
    .filter(item => item !== null);

  // 合并两个数组并返回
  return errorFromForms
      
  },

},
  methods: {
      // 删除图片
  handleRemove1(index) {
    this.$confirm('确定要删除这张图片吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
          // 清除所有图片相关的数据
    this.forms3[index].answerImageUrl = '';  // 清除图片URL
    this.forms3[index].fileId = null;        // 清除文件ID
    this.forms3[index].answerImageId = null; // 清除图片ID（如果存在）
    
    // 如果需要，也清除 image 对象
    this.forms3[index].image = {
      fileList: [],
      imageUrl: '',
      preview: false
    };

      this.$message.success('删除成功');
    }).catch(() => {
      // 取消删除
    });
  },
   // 图片上传前的验证
  beforeUpload(file) {
    const isImage = file.type.startsWith('image/');
    const isLt5M = file.size / 1024 / 1024 < 5;
    
    if (!isImage) {
      this.$message.error('只能上传图片文件!');
      return false;
    }
    if (!isLt5M) {
      this.$message.error('图片大小不能超过 5MB!');
      return false;
    }
    return true;
  },

  // 图片上传成功处理 - 修复版本
  handleSuccess1(response, file, index) {
    console.log("上传成功响应:", response);
    console.log("文件对象:", file);
    
    if (response && response.data && response.data.downloadUrl) {
      // 直接存储图片URL到对应的题目中
      this.$set(this.forms3[index], 'answerImageUrl', response.data.downloadUrl);
      this.$set(this.forms3[index], 'answerImageId', response.data.fileId);
      
      this.$message.success('图片上传成功');
      
      // 打印调试信息
      console.log(`第${index + 1}题上传的图片:`, this.forms3[index].answerImageUrl);
    } else {
      this.$message.error('上传成功，但未获取到有效的图片URL');
    }
  },

  // 初始化表单数据时确保有图片字段
  initializeForms() {
    // 确保每个主观题都有图片相关的字段
    this.forms3 = this.forms3.map(form => {
      return {
        ...form,
        answerImageUrl: form.answerImageUrl || '',
        answerImageId: form.answerImageId || ''
      };
    });
  },
    // 打开最新作业成绩
   async turnOpen(item){
      console.log(item,'item')
        try {
        const headers = { 'satoken': localStorage.getItem('token') };
        const params = {
          courseMsgId:item.courseMsgId,
          studentNumber:JSON.parse(localStorage.getItem('user')).studentNumber
        }
        const res = await this.$http.get(
          `${this.$config.API_BASE_URL}/hz-university-pc/student/read`,
          { params, headers }
        );
        if (res.data.code === 200) {
            this.$message({
					message: res.data.msg,
					type: 'success'
					});
          this.homes()
          this.goDetail(item)
        }
        
      } catch (error) {
        console.error("加载数据失败", error);
      }

    },
    //重做
   async reset(){
      this.showDialogs2 = false
      this.showDialogs1 = true
      console.log(this.courseMsgId,'courseMsgId')
      const params = {
        courseMsgId:this.courseMsgId,
        // studentNumber:JSON.parse(localStorage.getItem('user')).studentNumber
       }
        try {
        const headers = { 'satoken': localStorage.getItem('token') };
        const res = await this.$http.get(
          `${this.$config.API_BASE_URL}/hz-university-pc/student/courseMsg`,
          {params,headers }
        );
        if (res.data.code === 200) {
          const data = res.data.data;
          this.forms = data.one.map(item => {
      // 确保 options 是数组，并提取冒号后的内容
      const options = (item.options || []).map(opt => {
        // 分割字符串，取冒号后的部分
        const parts = opt.split(':');
        // 如果没找到冒号，返回原字符串；否则返回冒号后的部分
        return parts.length > 1 ? parts[1].trim() : opt;
      });
      
      // 解析正确答案（假设 correctAnswer 是像 "A" 或 "A,B" 这样的字符串）
      const correctAnswers = item.correctAnswer ? 
        item.correctAnswer.split(',').map(s => s.trim()) : 
        [];
      
      const answers = options.map((option, index) => {
        const label = String.fromCharCode(65 + index); // A, B, C...
        return {
          label,
          value: option,
          checked: null
        };
      });
          
          return {
            question: item.questionContent,
            answers: answers,
            // 保留原始数据中的其他字段
            ...item
          };
        }) || [];
                this.forms1 = data.two.map(item => {
      // 确保 options 是数组，并提取冒号后的内容
      const options = (item.options || []).map(opt => {
        // 分割字符串，取冒号后的部分
        const parts = opt.split(':');
        // 如果没找到冒号，返回原字符串；否则返回冒号后的部分
        return parts.length > 1 ? parts[1].trim() : opt;
      });
      
      // 解析正确答案（假设 correctAnswer 是像 "A" 或 "A,B" 这样的字符串）
      const correctAnswers = item.correctAnswer ? 
        item.correctAnswer.split(',').map(s => s.trim()) : 
        [];
      
      const answers = options.map((option, index) => {
        const label = String.fromCharCode(65 + index); // A, B, C...
        return {
          label,
          value: option,
          checked: null
        };
      });
          
          return {
            question: item.questionContent,
            answers: answers,
            // 保留原始数据中的其他字段
            ...item
          };
        }) || [];
          this.forms2 = data.three.map(item => {
           // 确保 options 是数组，并提取冒号后的内容
      const options = (item.options || []).map(opt => {
        // 分割字符串，取冒号后的部分
        const parts = opt.split(':');
        // 如果没找到冒号，返回原字符串；否则返回冒号后的部分
        return parts.length > 1 ? parts[1].trim() : opt;
      });
      
      // 解析正确答案（假设 correctAnswer 是像 "A" 或 "A,B" 这样的字符串）
      const correctAnswers = item.correctAnswer ? 
        item.correctAnswer.split(',').map(s => s.trim()) : 
        [];
      
      const answers = options.map((option, index) => {
        const label = String.fromCharCode(65 + index); // A, B, C...
        return {
          label,
          value: option,
          checked: null
        };
      });
          return {
            question: item.questionContent,
            answers: answers,
            // 保留原始数据中的其他字段
            ...item
          };
        }) || [];
          this.forms3 = data.four.map(item => {

          
          return {
            question: item.questionContent,
            
    questionId: item.questionId,  // 假设 questionId 存在
    answers: item.answers || [],    // 确保 answers 数组存在，避免错误
    answerImageUrl: item.questionAnswerFileVO.downloadUrl || null,
            ...item
          };
        }) || [];
          console.log(data,'datadata')
          console.log(this.forms,'this.forms')
          this.singlescore = this.forms[0].score
          this.multiplescore = this.forms1[0].score
          this.judgmentscore = this.forms2[0].score
          this.subjectivescore = this.forms3[0].score
          console.log(this.forms3,'this.forms3')
            this.$message({
                type: 'success',
                message: res.data.msg
              });
        }
      } catch (error) {
        console.error("加载数据失败", error);
      }
    },
    //查看最终试卷
   async goDetail(selection){
        this.showDialogs2 = true
        console.log('selectionselection',selection);
        const courseMsgId = selection.courseMsgId || ''
        this.courseMsgId = courseMsgId
       const params = {
        courseMsgId:courseMsgId,
        studentNumber:JSON.parse(localStorage.getItem('user')).studentNumber
       }
       console.log(params,'1213214et')
        try {
        const headers = { 'satoken': localStorage.getItem('token') };
        const res = await this.$http.get(
          `${this.$config.API_BASE_URL}/hz-university-pc/student/courseMsgTvAnswer`,
          {params,headers }
        );
        if (res.data.code === 200) {
          const data = res.data.data;
          this.totalMark = data.totalMark || '无';
          this.curriculumName = selection.curriculumName || ''
          this.passMark = data.passMark || '无';
          this.oneCount = data.oneCount || '0';
          this.twoCount = data.twoCount || '0';
          this.threeCount = data.threeCount || '0';
          this.fourCount = data.fourCount || '0';
          this.forms = data.one.map(item => {
      // 确保 options 是数组，并提取冒号后的内容
      const options = (item.options || []).map(opt => {
        // 分割字符串，取冒号后的部分
        const parts = opt.split(':');
        // 如果没找到冒号，返回原字符串；否则返回冒号后的部分
        return parts.length > 1 ? parts[1].trim() : opt;
      });
      
      // 解析正确答案（假设 correctAnswer 是像 "A" 或 "A,B" 这样的字符串）
      const correctAnswers = item.correctAnswer ? 
        item.correctAnswer.split(',').map(s => s.trim()) : 
        [];
      
      const answers = options.map((option, index) => {
        const label = String.fromCharCode(65 + index); // A, B, C...
        return {
          label,
          value: option,
          checked: correctAnswers.includes(label) // 根据正确答案设置初始状态
        };
      });
          
          return {
            question: item.questionContent,
            answers: answers,
            // 保留原始数据中的其他字段
            ...item
          };
        }) || [];
                this.forms1 = data.two.map(item => {
      // 确保 options 是数组，并提取冒号后的内容
      const options = (item.options || []).map(opt => {
        // 分割字符串，取冒号后的部分
        const parts = opt.split(':');
        // 如果没找到冒号，返回原字符串；否则返回冒号后的部分
        return parts.length > 1 ? parts[1].trim() : opt;
      });
      
      // 解析正确答案（假设 correctAnswer 是像 "A" 或 "A,B" 这样的字符串）
      const correctAnswers = item.correctAnswer ? 
        item.correctAnswer.split(',').map(s => s.trim()) : 
        [];
      
      const answers = options.map((option, index) => {
        const label = String.fromCharCode(65 + index); // A, B, C...
        return {
          label,
          value: option,
          checked: correctAnswers.includes(label) // 根据正确答案设置初始状态
        };
      });
          
          return {
            question: item.questionContent,
            answers: answers,
            // 保留原始数据中的其他字段
            ...item
          };
        }) || [];
          this.forms2 = data.three.map(item => {
           // 确保 options 是数组，并提取冒号后的内容
      const options = (item.options || []).map(opt => {
        // 分割字符串，取冒号后的部分
        const parts = opt.split(':');
        // 如果没找到冒号，返回原字符串；否则返回冒号后的部分
        return parts.length > 1 ? parts[1].trim() : opt;
      });
      
      // 解析正确答案（假设 correctAnswer 是像 "A" 或 "A,B" 这样的字符串）
      const correctAnswers = item.correctAnswer ? 
        item.correctAnswer.split(',').map(s => s.trim()) : 
        [];
      
      const answers = options.map((option, index) => {
        const label = String.fromCharCode(65 + index); // A, B, C...
        return {
          label,
          value: option,
          checked: correctAnswers.includes(label) // 根据正确答案设置初始状态
        };
      });
          return {
            question: item.questionContent,
            answers: answers,
            // 保留原始数据中的其他字段
            ...item
          };
        }) || [];
          this.forms3 = data.four.map(item => {

          
          return {
            question: item.questionContent,
            
    questionId: item.questionId,  // 假设 questionId 存在
    answers: item.answers || [],    // 确保 answers 数组存在，避免错误
    answerImageUrl: item.questionAnswerFileVO.downloadUrl || null,
            ...item
          };
        }) || [];
          console.log(data,'datadata')
          console.log(this.forms,'this.forms')
          this.singlescore = this.forms[0].score
          this.multiplescore = this.forms1[0].score
          this.judgmentscore = this.forms2[0].score
          this.subjectivescore = this.forms3[0].score
          console.log(this.forms3,'this.forms3')
            this.$message({
                type: 'success',
                message: res.data.msg
              });
        }
      } catch (error) {
        console.error("加载数据失败", error);
      }

    },
          close222(){
        this.showDialogs2 = false
        this.currentFormIndex= 0 ,
        this.currentFormIndex1= 0 ,
        this.currentFormIndex2= 0 ,
        this.currentFormIndex3= 0 ,
                this.currentFormIndex9= 0 ,
        this.currentFormIndex8= 0 ,
        this.currentFormIndex7= 0 ,
        this.currentFormIndex6= 0 ,
        this.forms = []
        this.forms1 = []
        this.forms2 = []
        this.forms3 = []
        // this.userName = ''
        // this.targetScore = ''
        this.totalMark = ''
        this.passMark =''
         this.oneCount = ''
         this.twoCount = ''
        this.threeCount = ''
        this.fourCount = ''

      },
    //提交
    submithomework(){

  // 创建一个空数组用于存储答案对象
  let result = [];
  // 先检查是否所有选项都已填选
  let allAnswered = true;
  let allAnswered1 = true;
  let allAnswered2 = true;
   let allAnswered3 = true;
  // 遍历所有单选问题答案
  // 处理单选题 (forms)
  this.forms.forEach(form => {
    const selectedAnswer = form.answers.find(answer => answer.checked);
    
    if (selectedAnswer) {
      result.push({
        answerId: form.answerId || null,   // 使用 form 中的 answerId
        questionId: form.questionId,       // 问题的ID
        answer: selectedAnswer.label      // 选中的答案文本
      });
    } else {
      allAnswered = false;
    }
  });

    // 遍历所有多选问题答案
  this.forms1.forEach(form => {
    // 筛选出所有已选中的答案，并将它们的标签（label）拼接成一个字符串
    const selectedAnswers = form.answers
      .filter(answer => answer.checked)  // 只选择已选中的答案
      .map(answer => answer.label)       // 提取选项标签
      .join(',');                        // 将选项标签连接为一个字符串，使用逗号分隔

    // 如果有选中的答案，构造一个包含 answerId, questionId, answer 的对象
    if (selectedAnswers) {
      result.push({
        answerId: form.answerId,      // 问题的answerId
        questionId: form.questionId,  // 问题的questionId
        answer: selectedAnswers      // 拼接后的答案字符串
      });
    }
            // 检查是否每个问题都有至少一个选项被选中
    const allCheckedForQuestion1 = form.answers.some(answer => answer.checked);
    if (!allCheckedForQuestion1) {
      allAnswered1 = false;
    }
  });

      // 遍历所有判断问题答案
this.forms2.forEach(form => {
  const selectedAnswer = form.answers.find(answer => answer.checked);
  
  if (selectedAnswer) {
    result.push({
      answerId: form.answerId || null,   // 使用form中的answerId
      questionId: form.questionId,       // 问题的ID
      answer: selectedAnswer.label      // 选中的答案文本
    });
  } else {
    allAnswered2 = false;
  }
});
        // 遍历所有主观问题答案
  this.forms3.forEach(form => {    
        result.push({
          answerId: form.answerId,   // 选项的ID
          questionId: form.questionId, // 问题的ID
          answer:form.answer,
           fileId: form.answerImageId || null 
        });
      //检查主观题答案是否都有
        if (!form.answer || form.answer.trim() === "") {  // 检查答案是否为空
      allAnswered3 = false;  // 如果有空答案，标记为未回答
    } 
  });
  
  // 如果有问题没有被填选，则弹出提示
  if (!allAnswered) {
    this.$message({
				message: '有单选题没有被选择！',
				type: 'error'
						});
    return; // 如果没有填选，停止继续执行
  }
    // 如果有问题没有被填选，则弹出提示
  if (!allAnswered1) {
    this.$message({
				message: '有多选题没有被选择！',
				type: 'error'
						});
    return; // 如果没有填选，停止继续执行
  }
      // 如果有问题没有被填选，则弹出提示
  if (!allAnswered2) {
    this.$message({
				message: '有判断题没有被选择！',
				type: 'error'
						});
    return; // 如果没有填选，停止继续执行
  }
        // 如果有问题没有被填选，则弹出提示
  if (!allAnswered3) {
    this.$message({
				message: '有主观题没有被填！',
				type: 'error'
						});
    return; // 如果没有填选，停止继续执行
  }
  // 打印结果数组
  // console.log(result);
  // 在提交前检查数据
console.log('主观题数据:', this.forms3);
console.log('最终提交数据:', result);
  if(result == ''){
        this.$message({
				message: '老师还没有发布任何题目！',
				type: 'error'
				});
  }else{
          const headers = {
        'satoken': localStorage.getItem('token'),
      };
       this.$http.post(`${this.$config.API_BASE_URL}/hz-university-pc/student/courseMsgSubmit`, result, { headers }).then((resp) =>{
              let data = resp.data;
              console.log(data, 'data');
              if(data.code =='200'){

							this.$message({
								message: data.msg,
								type: 'success'
						});
            this.showDialogs1 = false;
            this.$router.go(0); 
						
						}else{
							this.$message.error(data.msg);
						}
            })
          .catch((error) => {
          console.error("数据请求失败", error);
        });
  }
  
    },
  // 切换选项选中状态
  toggleCheck(formIndex, answerIndex) {
       // 先取消所有选中
    this.forms[formIndex].answers.forEach(a => a.checked = false);
    // 再选中当前项
    this.forms[formIndex].answers[answerIndex].checked = true;
  },
      // 切换选项选中状态
  toggleCheck1(formIndex, answerIndex) {
    this.forms1[formIndex].answers[answerIndex].checked = 
      !this.forms1[formIndex].answers[answerIndex].checked;
  },
   // 切换选项选中状态
  toggleCheck2(formIndex, answerIndex) {
       // 先取消所有选中
    this.forms2[formIndex].answers.forEach(a => a.checked = false);
    // 再选中当前项
    this.forms2[formIndex].answers[answerIndex].checked = true;
  },
  // 切换题目
switchForm(index) {
  this.currentFormIndex = index - 1;
  this.activeQuestionType = 'single'
  this.$nextTick(() => {
    // 更精确的选择器
   
    const questionEl = document.querySelector(
      `.single-question:nth-child(${index})`
    );
    
    if (questionEl) {
      questionEl.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' 
      });
      
      // 添加临时class用于高亮
      const highlightClass = 'highlight-' + Date.now();
      questionEl.classList.add(highlightClass);
      
      setTimeout(() => {
        questionEl.classList.remove(highlightClass);
      }, 1000);
    }
  });
},
// 切换题目
switchForm1(index) {
  this.currentFormIndex1 = index - 1;
  this.activeQuestionType = 'multiple'
  this.$nextTick(() => {
    // 更精确的选择器
    const questionEl = document.querySelector(
      `.multiple-question:nth-child(${index})`
    );
    
    if (questionEl) {
      questionEl.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' 
      });
      
      // 添加临时class用于高亮
      const highlightClass = 'highlight-' + Date.now();
      questionEl.classList.add(highlightClass);
      
      setTimeout(() => {
        questionEl.classList.remove(highlightClass);
      }, 1000);
    }
  });
},
// 切换题目
switchForm2(index) {
  this.currentFormIndex2 = index - 1;
  this.activeQuestionType = 'judge'
  this.$nextTick(() => {
    // 更精确的选择器
    const questionEl = document.querySelector(
      `.judge-question:nth-child(${index})`
    );
    
    if (questionEl) {
      questionEl.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' 
      });
      
      // 添加临时class用于高亮
      const highlightClass = 'highlight-' + Date.now();
      questionEl.classList.add(highlightClass);
      
      setTimeout(() => {
        questionEl.classList.remove(highlightClass);
      }, 1000);
    }
  });
},
// 切换题目
switchForm3(index) {
  this.currentFormIndex3 = index - 1;
  this.activeQuestionType = 'subjective'
  this.$nextTick(() => {
    // 更精确的选择器
    const questionEl = document.querySelector(
      `.subjective-question:nth-child(${index})`
    );
    
    if (questionEl) {
      questionEl.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' 
      });
      
      // 添加临时class用于高亮
      const highlightClass = 'highlight-' + Date.now();
      questionEl.classList.add(highlightClass);
      
      setTimeout(() => {
        questionEl.classList.remove(highlightClass);
      }, 1000);
    }
  });
},
                // 切换题目
switchForm9(index) {
  this.currentFormIndex9 = index - 1;
   this.activeQuestionType = 'single'
  this.$nextTick(() => {
    // 更精确的选择器
   
    const questionEl = document.querySelector(
      `.single-question:nth-child(${index})`
    );
    
    if (questionEl) {
      questionEl.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' 
      });
      
      // 添加临时class用于高亮
      const highlightClass = 'highlight-' + Date.now();
      questionEl.classList.add(highlightClass);
      
      setTimeout(() => {
        questionEl.classList.remove(highlightClass);
      }, 1000);
    }
  });
},
// 切换题目
switchForm8(index) {
  this.currentFormIndex8 = index - 1;
  this.activeQuestionType = 'multiple'
  this.$nextTick(() => {
    // 更精确的选择器
    const questionEl = document.querySelector(
      `.multiple-question:nth-child(${index})`
    );
    
    if (questionEl) {
      questionEl.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' 
      });
      
      // 添加临时class用于高亮
      const highlightClass = 'highlight-' + Date.now();
      questionEl.classList.add(highlightClass);
      
      setTimeout(() => {
        questionEl.classList.remove(highlightClass);
      }, 1000);
    }
  });
},
// 切换题目
switchForm7(index) {
  this.currentFormIndex7 = index - 1;
  this.activeQuestionType = 'judge'
  this.$nextTick(() => {
    // 更精确的选择器
    const questionEl = document.querySelector(
      `.judge-question:nth-child(${index})`
    );
    
    if (questionEl) {
      questionEl.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' 
      });
      
      // 添加临时class用于高亮
      const highlightClass = 'highlight-' + Date.now();
      questionEl.classList.add(highlightClass);
      
      setTimeout(() => {
        questionEl.classList.remove(highlightClass);
      }, 1000);
    }
  });
},
// 切换题目
switchForm6(index) {
  this.currentFormIndex6 = index - 1;
  this.activeQuestionType = 'subjective'
  this.$nextTick(() => {
    // 更精确的选择器
    const questionEl = document.querySelector(
      `.subjective-question:nth-child(${index})`
    );
    
    if (questionEl) {
      questionEl.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center' 
      });
      
      // 添加临时class用于高亮
      const highlightClass = 'highlight-' + Date.now();
      questionEl.classList.add(highlightClass);
      
      setTimeout(() => {
        questionEl.classList.remove(highlightClass);
      }, 1000);
    }
  });
},
//批改中
correcting(){
          this.$notify.info({
          title: '老师正在批改作业',
          message: '请耐心等待批改完成~'
        });
},
  //去提交
    async goSubmit(selection){

       console.log(selection,'selections')
       this.totalMark = selection.totalMark || ''
       this.passMark = selection.passMark || ''
       this.curriculumName = selection.curriculumName || ''

       this.courseMsgId = selection.courseMsgId || ''
       const params = {
        courseMsgId:this.courseMsgId,
        studentNumber:JSON.parse(localStorage.getItem('user')).studentNumber
       }
        try {
        const headers = { 'satoken': localStorage.getItem('token') };
        const res = await this.$http.get(
          `${this.$config.API_BASE_URL}/hz-university-pc/student/courseMsgTvAnswer`,
          {params,headers }
        );
        if (res.data.code === 200) {
          const data = res.data.data;
          this.forms = data.one.map(item => {
      // 确保 options 是数组，并提取冒号后的内容
      const options = (item.options || []).map(opt => {
        // 分割字符串，取冒号后的部分
        const parts = opt.split(':');
        // 如果没找到冒号，返回原字符串；否则返回冒号后的部分
        return parts.length > 1 ? parts[1].trim() : opt;
      });
      
      // 解析正确答案（假设 correctAnswer 是像 "A" 或 "A,B" 这样的字符串）
      const correctAnswers = item.correctAnswer ? 
        item.correctAnswer.split(',').map(s => s.trim()) : 
        [];
      
      const answers = options.map((option, index) => {
        const label = String.fromCharCode(65 + index); // A, B, C...
        return {
          label,
          value: option,
          checked: null
        };
      });
          
          return {
            question: item.questionContent,
            answers: answers,
            // 保留原始数据中的其他字段
            ...item
          };
        }) || [];
                this.forms1 = data.two.map(item => {
      // 确保 options 是数组，并提取冒号后的内容
      const options = (item.options || []).map(opt => {
        // 分割字符串，取冒号后的部分
        const parts = opt.split(':');
        // 如果没找到冒号，返回原字符串；否则返回冒号后的部分
        return parts.length > 1 ? parts[1].trim() : opt;
      });
      
      // 解析正确答案（假设 correctAnswer 是像 "A" 或 "A,B" 这样的字符串）
      const correctAnswers = item.correctAnswer ? 
        item.correctAnswer.split(',').map(s => s.trim()) : 
        [];
      
      const answers = options.map((option, index) => {
        const label = String.fromCharCode(65 + index); // A, B, C...
        return {
          label,
          value: option,
          checked: null
        };
      });
          
          return {
            question: item.questionContent,
            answers: answers,
            // 保留原始数据中的其他字段
            ...item
          };
        }) || [];
          this.forms2 = data.three.map(item => {
           // 确保 options 是数组，并提取冒号后的内容
      const options = (item.options || []).map(opt => {
        // 分割字符串，取冒号后的部分
        const parts = opt.split(':');
        // 如果没找到冒号，返回原字符串；否则返回冒号后的部分
        return parts.length > 1 ? parts[1].trim() : opt;
      });
      
      // 解析正确答案（假设 correctAnswer 是像 "A" 或 "A,B" 这样的字符串）
      const correctAnswers = item.correctAnswer ? 
        item.correctAnswer.split(',').map(s => s.trim()) : 
        [];
      
      const answers = options.map((option, index) => {
        const label = String.fromCharCode(65 + index); // A, B, C...
        return {
          label,
          value: option,
          checked: null
        };
      });
          return {
            question: item.questionContent,
            answers: answers,
            // 保留原始数据中的其他字段
            ...item
          };
        }) || [];
          this.forms3 = data.four.map(item => {

          
          return {
            question: item.questionContent,
            
    questionId: item.questionId,  // 假设 questionId 存在
    answers: item.answers || [],    // 确保 answers 数组存在，避免错误
            ...item
          };
        }) || [];
        if(this.forms.length > 0 || this.forms1.length > 0 || this.forms2.length > 0 || this.forms3.length > 0){
                this.showDialogs1 = true
                console.log(this.forms,this.forms1,this.forms2,this.forms3,'111')
                          console.log(data,'datadata')
          console.log(this.forms,'this.forms')
          this.singlescore = this.forms[0].score
          this.multiplescore = this.forms1[0].score
          this.judgmentscore = this.forms2[0].score
          this.subjectivescore = this.forms3[0].score
          console.log(this.forms3,'this.forms3')
            this.$message({
                type: 'success',
                message: res.data.msg
              });
        }else{
            this.$notify({
              title: '老师正在发布作业',
          message: '请耐心等待发布完成~',
          type: 'warning'
        });
        }

        }
      } catch (error) {
        console.error("加载数据失败", error);
      }

    },
    //观看视频
     watchVideo(selection){
      console.log(selection,'selections')
      this.courseMsgId = selection.courseMsgId || ''
      const downloadUrl = selection.fileDownloadVO.downloadUrl ||'';
        if(downloadUrl){
            this.videoUrl = downloadUrl,
            this.dialogVisible2 = true

        }else{
            this.error = '获取视频地址失败';
            this.$message.error(this.error);

        }
    },
     // 重置计时器
    resetVideoTimer() {
      if (this.videoTimer.timer) {
        clearInterval(this.videoTimer.timer);
      }
      this.videoTimer = {
        startTime: null,
        timer: null,
        totalSeconds: 0,
        isPlaying: false
      };
    },
    
// 修改setupVideoEventListeners方法
setupVideoEventListeners() {
  const videoPlayer = this.$refs.videoPlayer;
  if (!videoPlayer) return;
  
  // 使用箭头函数或bind保持this上下文
  videoPlayer.removeEventListener('play', this.handlePlay);
  videoPlayer.removeEventListener('pause', this.handlePause);
  videoPlayer.removeEventListener('ended', this.handleEnded);
  
  videoPlayer.addEventListener('play', () => this.handlePlay());
  videoPlayer.addEventListener('pause', () => this.handlePause());
  videoPlayer.addEventListener('ended', () => this.handleEnded());
},
    // 处理播放事件
    handlePlay() {
      // if (this.videoTimer.isPlaying) return;
      
      // this.videoTimer.startTime = new Date();
      // this.videoTimer.isPlaying = true;
      
      // // 启动计时器，每秒更新一次
      // this.videoTimer.timer = setInterval(() => {
      //   this.videoTimer.totalSeconds++;
      // }, 1000);
      
      // console.log('视频开始播放，计时开始');
          if (this.videoTimer.isPlaying) return;
    
    this.videoTimer.startTime = new Date();
    this.videoTimer.isPlaying = true;
    
    // 启动计时器，每秒更新一次
    this.videoTimer.timer = setInterval(() => {
      this.videoTimer.totalSeconds++;
    }, 1000);
    
    // 启动5分钟验证定时器
    this.startVerifyTimer();
    
    console.log('视频开始播放，计时开始');
    },
      // 启动验证定时器
  startVerifyTimer() {
    // 先清除已有定时器
    this.clearVerifyTimer();
    
    // 设置20分钟后触发验证
    this.verifyInterval = setTimeout(() => {
      this.triggerVerification();
    }, 20 * 60 * 1000);
  },
    // 触发验证
  triggerVerification() {
    const videoPlayer = this.$refs.videoPlayer;
    if (videoPlayer) {
      videoPlayer.pause(); // 暂停视频
    }
    
    this.showSliderVerify = true; // 显示验证对话框
    this.sliderValue = 0; // 重置滑块值
  },
    // 清除验证定时器
  clearVerifyTimer() {
    if (this.verifyInterval) {
      clearTimeout(this.verifyInterval);
      this.verifyInterval = null;
    }
  },
     // 滑块验证处理
  handleSliderVerify(value) {
    if (value >= this.verifyThreshold) {
      // 验证通过
      this.showSliderVerify = false;
      const videoPlayer = this.$refs.videoPlayer;
      if (videoPlayer) {
        videoPlayer.play(); // 继续播放
      }
      
      // 重新启动5分钟验证定时器
      this.startVerifyTimer();
    }
  }, 
    // 滑块提示格式化
  formatSliderTooltip(val) {
    return `${val}%`;
  },
    // 处理暂停事件
    handlePause() {
      if (!this.videoTimer.isPlaying) return;
      this.stopTimerAndLog();
    },
    
    // 处理结束事件
    handleEnded() {
      this.stopTimerAndLog();
    },
    
    // 停止计时并打印结果
    stopTimerAndLog() {
      if (!this.videoTimer.isPlaying) return;
      clearInterval(this.videoTimer.timer);
      this.videoTimer.isPlaying = false;   
      const endTime = new Date();
      const duration = Math.floor((endTime - this.videoTimer.startTime) / (1000 * 60)); // 毫秒 → 分钟（取整） 
      // 格式化时间显示
      const formattedTime = this.formatTime(this.videoTimer.totalSeconds);   
      console.log('视频播放统计:', {
        startTime: this.videoTimer.startTime,
        endTime: endTime,
        durationSeconds: this.videoTimer.totalSeconds,
        formattedDuration: formattedTime,
        calculatedDuration:((endTime - this.videoTimer.startTime) / (1000 * 60)) + 's'
      });  
      console.log(`本次播放时长: ${formattedTime} (${duration + '分钟'})`);
     
      this.results(this.courseMsgId,duration)
    },
    //结果
    async results(courseMsgId,duration){
      const params = {
        courseMsgId:courseMsgId,
        viewingTime:duration
      }
      console.log(courseMsgId,duration,'courseMsgId,duration')
        try {
        const headers = { 'satoken': localStorage.getItem('token') };
        const res = await this.$http.post(
          `${this.$config.API_BASE_URL}/hz-university-pc/student/studyTime`,params,
          {headers }
        );
        if (res.data.code === 200) {
                      this.$message({
                type: 'success',
                message: res.data.msg
              });
        }
      } catch (error) {
        console.error("加载数据失败", error);
      }
    },
    // 格式化时间为 HH:MM:SS
    formatTime(totalSeconds) {
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = Math.floor(totalSeconds % 60);
      
      return [
        hours.toString().padStart(2, '0'),
        minutes.toString().padStart(2, '0'),
        seconds.toString().padStart(2, '0')
      ].join(':');
    },
    closeclear(){
  //     const videoPlayer = this.$refs.videoPlayer;
  
  // // 先暂停视频（会触发pause事件）
  // if (videoPlayer) {
  //   videoPlayer.pause();
  // }
  
  // // 确保计时器停止
  // this.stopTimerAndLog();
  
  // // 重置状态
  // videoPlayer.currentTime = 0;
  // this.courseMsgId = '';
  // this.videoUrl = '';
  // this.dialogVisible2 = false;


      const videoPlayer = this.$refs.videoPlayer;
    
    // 先暂停视频（会触发pause事件）
    if (videoPlayer) {
      videoPlayer.pause();
    }
    
    // 确保计时器停止
    this.stopTimerAndLog();
    
    // 清除验证定时器
    this.clearVerifyTimer();
    
    // 重置状态
    videoPlayer.currentTime = 0;
    this.courseMsgId = '';
    this.videoUrl = '';
    this.dialogVisible2 = false;
    this.showSliderVerify = false;
    },
     beforeDestroy() {
    // 组件销毁前清理计时器
    if (this.videoTimer.timer) {
      clearInterval(this.videoTimer.timer);
    }
  },
    // 修改beforeDestroy
  beforeDestroy() {
    // 组件销毁前清理计时器
    if (this.videoTimer.timer) {
      clearInterval(this.videoTimer.timer);
    }
    // 清理验证定时器
    this.clearVerifyTimer();
  },
      goback(){
         this.$router.go(-1)
    },
    async homes(){
        this.loading2 = true
                
        try {
            const headers = { 'satoken': localStorage.getItem('token') };
            const res = await this.$http.get(
             `${this.$config.API_BASE_URL}/hz-university-pc/student/score_notification`, {
                  headers
                }
             );               
        if (res.data.code === 200) {
            const data = res.data.data || [];
            this.sum =data.sum ||'';
            this.vo = data.vo || []

            console.log(this.sum,this.vo,'datda')
             }
        } catch (error) {
                  console.error("加载专业数据失败", error)
                  this.loading2 = false
        }finally{
                  this.loading2 = false
          }
    },
   async tapclass(courseId){
          console.log(courseId,'courseIdcourseIdcourseId')
          this.loading2 = true;
                    try {
                  const headers = { 'satoken': localStorage.getItem('token') };
                  const res = await this.$http.get(
                  `${this.$config.API_BASE_URL}/hz-university-pc/student/getTeacher`, {
                 params: { courseId },
                  headers
                }
                  );               
                  if (res.data.code === 200) {
                         this.details = res.data.data || [];
                        console.log(this.details,'this.details')
                        this.className = this.details.courseName || ''
                        this.loading2 = false
                        this.helpLessonList(courseId)
                  }
                } catch (error) {
                  console.error("加载专业数据失败", error);
                  this.loading2 = false
                }finally{
                  this.loading2 = false
                }
    },
    async rightbotom(){
                    try {
                  const headers = { 'satoken': localStorage.getItem('token') };
                  const res = await this.$http.get(
                  `${this.$config.API_BASE_URL}/hz-university-pc/student/score_notification`, {
                 
                  headers
                }
                  );               
                  if (res.data.code === 200) {
                        this.newhomeworkList = res.data.data || [];
                        console.log(this.newhomeworkList,'this.newhomeworkList')
                  }
                } catch (error) {
                  console.error("加载专业数据失败", error);
                }
    },
async middletop() {
    try {
        const headers = { 
            'satoken': localStorage.getItem('token') || '' 
        };
        
        const res = await this.$http.get(
            `${this.$config.API_BASE_URL}/hz-university-pc/student/courseList`, 
            { headers }
        );
        
        if (res.data.code === 200) {
            this.classnum = res.data.data.count || '';  // 保持原样
            
            // 明确处理 null 或 undefined 的情况
            this.lessonLists = res.data.data.dtoList ? [...res.data.data.dtoList] : [];
            console.log(this.lessonLists, 'this.lessonLists');
            
            // 安全访问 lessonLists[0] 的属性
            const courseId = this.lessonLists[0]?.courseId;
            this.className = this.lessonLists[0]?.courseName || '';
            console.log(courseId, 'courseId');
            
            // 只有当 lessonLists 不为空时才调用后续方法
            if (this.lessonLists.length > 0) {
                this.counsellorDetail(courseId);
                this.helpLessonList(courseId);
            }
        }
    } catch (error) {
        console.error("加载专业数据失败", error);
        this.$message.error('加载数据失败: ' + (error.message || '未知错误')); // 可选：增加用户提示
    }
},
   async counsellorDetail(courseId){
              try {
                  const headers = { 'satoken': localStorage.getItem('token') };
                  const res = await this.$http.get(
                  `${this.$config.API_BASE_URL}/hz-university-pc/student/getTeacher`, {
                  params: { courseId }, // GET请求参数要放在params中
                  headers
                }
                  );               
                  if (res.data.code === 200) {
                        this.details = res.data.data || [];
                        console.log(this.details,'this.details')
                  }
                } catch (error) {
                  console.error("加载专业数据失败", error);
                }
    },
   async helpLessonList(courseId){
                    try {
                  const headers = { 'satoken': localStorage.getItem('token') };
                  const res = await this.$http.get(
                  `${this.$config.API_BASE_URL}/hz-university-pc/student/courseMsgList`, {
                  params: { courseId }, // GET请求参数要放在params中
                  headers
                }
                  );               
                  if (res.data.code === 200) {
                        this.bottomList = res.data.data || [];
                        console.log(this.bottomList,'this.bottomList')
                  }
                } catch (error) {
                  console.error("加载专业数据失败", error);
                }

    },
   async lefttop(){
              try {
                  const headers = { 'satoken': localStorage.getItem('token') };
                  const res = await this.$http.get(
                    `${this.$config.API_BASE_URL}/hz-university-pc/student/getOne`, { headers}
                  );               
                  if (res.data.code === 200) {
                        this.teadata = res.data.data || {};
                        this.mycounsellor = this.teadata.useName || this.teadata.userName || '未知'; // 兼容字段
                        this.myuserDepartment = this.teadata.userDepartment || this.teadata.userDepartment || '未知'; // 兼容字段
                        this.myphone = this.teadata.phone || this.teadata.phone || '未知'; // 兼容字段
                        console.log(this.teadata,'this.teadata')
                        console.log(this.mycounsellor,'this.mycounsellor')
                  }
                } catch (error) {
                  console.error("加载专业数据失败", error);
                }
    },
      quit(){
            const headers = {
                'satoken': localStorage.getItem('token'),
              };
              this.$confirm('此操作退出登录, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
            this.$http.get(`${this.$config.API_BASE_URL}/hz-university-pc/user/logout`,{ headers }).then((resp) => {
            let data = resp.data;
            if(data.code == '200') {       						
                this.$router.push({path:'/'})
                 localStorage.clear();
            this.$message({
                type: 'success',
                message: '退出登录成功!'
              });
            } else {
              this.$message.error(data.msg);
            }
          }); 
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消退出登录'
              });          
            });
        },
        changePassword() {
      this.dialogVisible = true
    },
    //修改密码
      handleDataFromChild2(data) {
      console.log("父组件收到数据:", data); 
      const headers = {
        'satoken': localStorage.getItem('token'),
      };
       this.$http.post(`${this.$config.API_BASE_URL}/hz-university-pc/user/updateUserPassWord`, data, { headers }).then((resp) =>{
              let data = resp.data;
              console.log(data, 'data');
              if(data.code =='200'){

							this.$message({
								message: data.msg,
								type: 'success'
						});
             this.dialogVisible = false
						
						}else{
							this.$message.error(data.msg);
						}
            })
          .catch((error) => {
          console.error("数据请求失败", error);
        });
    },
    changeInfor(){
          this.dialogVisible1 = true
          const headers = {
        'satoken': localStorage.getItem('token'),
      };
       this.$http.get(`${this.$config.API_BASE_URL}/hz-university-pc/user/getOneUser`,  { headers }).then((resp) =>{
              let data = resp.data;
              console.log(data, 'data');
              if(data.code =='200'){
                this.inform = data.data
							this.$message({
								message: data.msg,
								type: 'success'
						});
						
						}else{
							this.$message.error(data.msg);
						}
            })
          .catch((error) => {
          console.error("数据请求失败", error);
        });
        },
            handleDataFromInfo2(data){
            console.log("父组件收到数据:", data); 
      const headers = {
        'satoken': localStorage.getItem('token'),
      };
      const mailbox = data.email;
      const datainfo = {
        mailbox:mailbox,
        phone:data.phone

      }

       this.$http.post(`${this.$config.API_BASE_URL}/hz-university-pc/user/updateUser`, datainfo, { headers }).then((resp) =>{
              let data = resp.data;
              console.log(data, 'data');
              if(data.code =='200'){

							this.$message({
								message: data.msg,
								type: 'success'
						});
						this.dialogVisible1 = false
						}else{
							this.$message.error(data.msg);
						}
            })
          .catch((error) => {
          console.error("数据请求失败", error);
        });
   
    },
   async check() {  
      this.showDialogs = true;
              try {
                  const headers = { 'satoken': localStorage.getItem('token') };
                  const res = await this.$http.get(
                    `${this.$config.API_BASE_URL}/hz-university-pc/course/get_course_type`, { headers}
                  );               
                  if (res.data.code === 200) {
                      this.options = res.data.data || [];
                      console.log(this.options,'this.options')
                  }
                } catch (error) {
                  console.error("加载专业数据失败", error);
                }
                this.requestList1()


            },
        async requestList1(){
                 try {
                  const headers = { 'satoken': localStorage.getItem('token') };
                  const res = await this.$http.get(
                    `${this.$config.API_BASE_URL}/hz-university-pc/weakStudent/query`, { headers}
                  );               
                  if (res.data.code === 200) {
                        this.classData = res.data.data || [];
                        console.log(this.classData,'this.classData')
                  }
                } catch (error) {
                  console.error("加载专业数据失败", error);
                }
         },   
           async ascertain() {
            if (!this.classList) {
              this.$message({
                message: '请选择需要帮扶课程',
                type: 'error'
              });
              return; // 直接返回，不执行后续逻辑
            }

  try {
    // 添加确认对话框
    await this.$confirm('确定要提交帮扶课程申请吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    });

    this.loading1 = true;
    const headers = { 
      'satoken': localStorage.getItem('token') 
    };
    const params = {
      courseName: this.classList
    };

    const res = await this.$http.post(
      `${this.$config.API_BASE_URL}/hz-university-pc/weakStudent/add`, 
      params, 
      { headers }
    );

    if (res.data.code === 200) {
      this.$message({
        message: res.data.msg,
        type: 'success'
      });
      
    } else if (res.data.code === 400) {
      this.$message({
        message: res.data.msg,
        type: 'error'
      });
    }
    this.requestList1()
  } catch (error) {
    // 区分是用户取消还是请求出错
    if (error !== 'cancel') {  // 非取消操作的真实错误
      console.error("提交失败", error);
      this.$message.error('提交失败，请重试');
    } else {
      // 用户点击了取消
      this.$message({
        type: 'info',
        message: '已取消提交'
      });
    }
  } finally {
    this.loading1 = false;
  }
}

        

    },




  }

</script>

<style scoped>
/* 验证对话框整体样式 */
.verify-dialog {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
}

.verify-dialog .el-dialog__header {
  display: none; /* 隐藏默认标题 */
}

.verify-container {
  padding: 25px 30px;
}

/* 头部样式 */
.verify-header {
  text-align: center;
  margin-bottom: 25px;
}

.verify-header i {
  font-size: 40px;
  color: #409EFF;
  margin-bottom: 10px;
}

.verify-header h3 {
  margin: 5px 0;
  font-size: 18px;
  color: #333;
}

.verify-tip {
  margin: 0;
  font-size: 14px;
  color: #999;
}

/* 滑块区域样式 */
.verify-body {
  position: relative;
}

.slider-track {
  height: 6px;
  background: #ebeef5;
  border-radius: 3px;
  margin-top: -8px;
  position: relative;
  z-index: 1;
}

.slider-progress {
  height: 100%;
  background: linear-gradient(90deg, #409EFF, #66b1ff);
  border-radius: 3px;
  transition: width 0.2s;
}

/* 自定义滑块按钮 */
.slider-button {
  width: 28px;
  height: 28px;
  background: #fff;
  border: 2px solid #409EFF;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
  transition: transform 0.2s;
}

.slider-button i {
  color: #409EFF;
  font-size: 14px;
}

/* 提示文字 */
.verify-hint, .verify-success {
  text-align: center;
  margin-top: 15px;
  font-size: 14px;
  color: #f56c6c;
}

.verify-success {
  color: #67c23a;
}

.verify-success i {
  margin-right: 5px;
  font-size: 16px;
}

/* 修改Element默认滑块样式 */
.verify-body .el-slider {
  margin-bottom: 0;
}

.verify-body .el-slider__runway {
  background: transparent !important;
  margin: 0 !important;
}

.verify-body .el-slider__bar {
  background: transparent !important;
}
.right-dialog2 {
  left: calc(50% - (495px + 1026px + 20px)/2 + 495px + 20px);
}
.dialog3 {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  width: 1026px;
    height: 80vh;
  background: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  z-index: 101;
      /* 新增滚动相关样式 */
  max-height: 80vh; /* 设置最大高度为视口的80% */
  overflow-y: auto; /* 垂直方向超出时显示滚动条 */
  display: flex;
  flex-direction: column; /* 确保内容垂直排列 */
}
 .titlebg {
  padding: 12px 15px;
  margin-bottom: 10px;
  border-radius: 6px;
  border: 1px solid #dcdfe6;
  transition: all 0.3s ease;
  cursor: pointer;
}

.titlebg:hover {
  border-color: #c0c4cc;
}
    .titlebg{
width: 450px;
height: 45px;
opacity: 0.5;
background: rgba(237, 243, 246, 1);
padding: 9px;
margin-bottom: 20px;
}
.left-dialog2 {
  left: calc(50% - (495px + 1026px + 20px)/2);
}
.dialog2 {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  width: 495px;
  height: 80vh;
  background: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  z-index: 101;
    /* 新增滚动相关样式 */
  max-height: 80vh; /* 设置最大高度为视口的80% */
  overflow-y: auto; /* 垂直方向超出时显示滚动条 */
  display: flex;
  flex-direction: column; /* 确保内容垂直排列 */
}
.box1center {
  background: #fff;
  border-radius: 0.625rem;
  padding: 0.9375rem;
  margin-bottom: 2vh;
  height: 25vh; /* 固定高度 */
  display: flex;
  flex-direction: column; /* 垂直布局 */
}

/* 头部固定（不滚动） */
.flex-between {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px; /* 和滚动区域间隔 */
}

/* 可滚动区域 */
.scrollable-content {
  flex: 1; /* 占满剩余空间 */
  overflow-y: auto; /* 垂直滚动 */
}



.courses-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.course-item {
  width: calc(25% - 10px);
  min-width: 200px;
  padding: 10px;
  background-color: #f4f4f4;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* 默认阴影（可选） */
  transition: all 0.3s ease; /* 平滑过渡效果 */
}

/* 鼠标悬浮时增强阴影 */
.course-item:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); /* 更明显的阴影 */
  transform: translateY(-2px); /* 轻微上浮（可选） */
  cursor: pointer; /* 鼠标指针变为手型 */
}
.password{

width: 150px;
height: 35px;
opacity: 1;
border-radius: 15px;
border: 1px solid rgba(39, 154, 255, 1);
margin: auto;

font-size: 20px;
font-weight: 500;
letter-spacing: 0px;
line-height: 28.96px;
color: rgba(130, 127, 127, 1);
text-align: center;
}
.shenhe{
width: 90px;
height: 35px;
opacity: 1;
border-radius: 50px;
background: rgba(250, 235, 220, 1);

font-size: 18px;
font-weight: 500;
letter-spacing: 0px;
/* line-height: 25px; */
color: rgba(252, 153, 121, 1);
text-align: center;
}
.bohui{
width: 90px;
height: 35px;
opacity: 1;
border-radius: 50px;
background: rgba(212, 48, 48, 0.2);

font-size: 18px;
font-weight: 500;
letter-spacing: 0px;
/* line-height: 25px; */
color: rgba(212, 48, 48, 1);
text-align: center;
}
.tongguo{
width: 90px;
height: 35px;
opacity: 1;
border-radius: 50px;
background: rgba(39, 154, 255, 0.2);

font-size: 18px;
font-weight: 500;
letter-spacing: 0px;
/* line-height: 25px; */
color: rgba(39, 154, 255, 1);
text-align: center;
}
.sure{

width: 111px;
height: 40px;
opacity: 1;
border-radius: 6px;
background: rgba(0, 129, 255, 1);

font-size: 18px;
font-weight: 700;
letter-spacing: 0px;
line-height: 20px;
color: rgba(255, 255, 255, 1);
text-align: center;
margin: auto 0;
margin-right: 10px;

}
.texttitles{

font-size: 12px;
font-weight: 500;
letter-spacing: 0px;
line-height: 17.38px;
color: rgba(153, 153, 153, 1);
text-align: left;
margin: auto 0;

}
.surebox{

width: 100%;
height: 60px;
opacity: 0.5;
border-radius: 5px;
background: rgba(219, 231, 238, 1);
display: flex;
justify-content: space-between;


}
::v-deep .custom-dialog {
  border-radius: 30px;
  background: #fff;
  border: 2px solid #fff;
  overflow: hidden;
}
::v-deep .custom-dialog .el-dialog__header,
::v-deep .custom-dialog .el-dialog__body {
  background: transparent;
}
.close-icon {
  position: absolute;
  top: 0.9375rem;
  right: 1.25rem;
  font-size: 1.5rem;
  cursor: pointer;
}
/* 对话框 */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
}
.dialog, .dialog1 {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  background: white;
  padding: 1.25rem;
  border-radius: 0.3125rem;
  box-shadow: 0 0 0.625rem rgba(0, 0, 0, 0.3);
  z-index: 101;
  max-height: 80vh;
  overflow-y: auto;
}

.dialog {
  width: 20.9375rem;
  height: 70vh;
  left: calc(40% - 28.125rem);
}

.dialog1 {
  width: 50rem;
  height: 70vh;
  left: calc(40% - 38.125rem + 31.9375rem + 1.25rem);
}

.notsub{
width: 105px;
height: 35px;
opacity: 1;
border-radius: 50px;
background: rgba(250, 235, 220, 1);
font-size: 15px;
font-weight: 500;
letter-spacing: 0px;
line-height: 18px;
color: rgba(252, 153, 121, 1);
text-align: center;
}
.detail{
width: 105px;
height: 35px;
opacity: 1;
border-radius: 50px;
background: rgba(39, 154, 255, 0.2);
font-size: 18px;
font-weight: 500;
letter-spacing: 0px;
line-height: 18px;
color: rgba(39, 154, 255, 1);
text-align: center;
}
.grading{
width: 105px;
height: 35px;
opacity: 1;
border-radius: 50px;
background: rgba(153, 153, 153, 0.2);
font-size: 18px;
font-weight: 500;
letter-spacing: 0px;
line-height: 18px;
color: rgba(102, 102, 102, 1);
text-align: center;
}
/* 滚动条样式 */
.homework-container-wrapper {
  height: 53vh; /* 根据需要调整高度 */
  overflow-y: auto; /* 启用垂直滚动条 */
}
.view-icon {

float: inline-end;
  cursor: pointer;
  transition: transform 0.2s;

}
.sse{
font-size: 14px;
font-weight: 500;
letter-spacing: 0px;
line-height: 20.27px;
color: rgba(102, 102, 102, 1);
/* margin-top: 1.7vh; */


}
.pigai{

font-size: 12px;
font-weight: 500;
letter-spacing: 0px;
line-height: 17.38px;
color: rgba(153, 153, 153, 1);

}
.homework-meta{
 position: absolute;
 right: 0;
}
.les {
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
}
.homework-indicator {
  width: 0.25rem;
  height: 3rem;
  background: rgba(17, 109, 255, 1);
  border-radius: 0.125rem;
}
/* 作业项 */
.homework-item {
  width: 100%;
  height: 5.5vh;
  display: flex;
  gap: 1rem;
  margin-bottom: 3%;
  position: relative;
    padding: 0.4rem;
  border-radius: 0.5rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  margin-bottom: 0.5rem;
  background: #fff;
  width: 100%;
}
.homework-item:hover {
  transform: translateY(-0.25rem);
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.15);
  cursor: pointer;
}
/* 滚动条 */
.over1 {
  flex: 1;
  overflow-y: auto;
  margin-top: 5%;
  padding-right: 0.3125rem;
}
/* 其他元素 */
.rednum {
  width: 2.4375rem;
  height: 1.5625rem;
  background: rgba(229, 16, 19, 1);
  border-radius: 0.3125rem;
  color: white;
  text-align: center;
  font-weight: 700;
  line-height: 1.45;
}
.rightbottom {
  width: 100%;
  height: 60vh;
  background: #fff;
  padding: 0.9375rem;
  border-radius: 0.625rem;
  margin-top: 2vh;
}

/* 文本样式 */
.text {
  font-size: 1.125rem;
  font-weight: 500;
  color: #333;
  margin-bottom: 0.625rem;
}
.notsub{
width: 105px;
height: 35px;
opacity: 1;
border-radius: 50px;
background: rgba(250, 235, 220, 1);

font-size: 15px;
font-weight: 500;
letter-spacing: 0px;
line-height: 18px;
color: rgba(252, 153, 121, 1);
text-align: center;



}
.detail{

width: 105px;
height: 35px;
opacity: 1;
border-radius: 50px;
background: rgba(39, 154, 255, 0.2);

font-size: 18px;
font-weight: 500;
letter-spacing: 0px;
line-height: 18px;
color: rgba(39, 154, 255, 1);
text-align: center;



}
.grading{

width: 105px;
height: 35px;
opacity: 1;
border-radius: 50px;
background: rgba(153, 153, 153, 0.2);

font-size: 18px;
font-weight: 500;
letter-spacing: 0px;
line-height: 18px;
color: rgba(102, 102, 102, 1);
text-align: center;



}
.courses-wrapper {
  width: 100%;
  overflow-x: auto;
  padding-bottom: 10px;
}





.courses-wrapper::-webkit-scrollbar {
  height: 8px;
}

.courses-wrapper::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 4px;
}

.courses-wrapper::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}
/* 基础样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.onetext{

font-size: 18px;
font-weight: 500;
letter-spacing: 0px;
line-height: 26.06px;
color: rgba(51, 51, 51, 1);
text-align: left;



}
.onelesson{

width: 300px;
height: 130px;
opacity: 0.5;
border-radius: 10px;
background: rgba(237, 243, 246, 1);
padding: 8px 17px;

}
.classes{  
    width: 100%;
}
.se{

font-size: 18px;
font-weight: 500;
letter-spacing: 0px;
line-height: 34.75px;
color: rgba(67, 67, 67, 1);
gap: 50px;
margin-top: 2vh;



}
.teaname{
    display: flex;
    justify-content: center;
    text-align: center;
    font-size: 28px;
    font-weight: 700;
    letter-spacing: 0px;
    line-height: 43.44px;
    color: rgba(51, 51, 51, 1);
    margin: 2vh 0;
}
.includuce{

font-size: 18px;
font-weight: 500;
letter-spacing: 0px;
line-height: 26.06px;
color: rgba(67, 67, 67, 1);
text-align: center;


}
.page-container {
  background-image: url('@/assets/pic/background.png');
  background-size: cover;
  background-position: center;
  min-height: 100vh;
  padding: 0 1.25rem;
  display: flex;
  flex-direction: column;
}

/* 顶部栏 */
.top {
  width: 100%;
  padding-top: 1.25rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.top-icons img {
  width: 3.125rem;
  height: 3.125rem;
  margin-left: 0.9375rem;
}

/* 搜索区域 */
.top2 {
  width: 100%;
  /* padding: 1.25rem 6.25rem 0; */
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.motto {
  font-size: 1.5rem;
  font-weight: 700;
  color: #5ea5ff;
}



/* 主要内容区域 */
.main-content {
  width: 100%;
  padding: 1.25rem 0;
  flex: 1;
}

.mainbox {
  width: 100%;
  height: 100%;
  display: flex;
  gap: 1.25rem;
}

.left-section {
  flex: 0.7;
  display: flex;
  flex-direction: column;
}

.middle-section {
  flex: 3;
  height: 77vh;
}
.right-section{
  flex: 0.9;
  height: 77vh;
}
.rightall {
  flex: 0.8;
  display: flex;
  flex-direction: column;
  height: 77vh;
}

/* 卡片样式 */
.box1left1, .box1center, .right {
  background: #fff;
  border-radius: 0.625rem;
  padding: 0.9375rem;
}

.box1left1 {
  height: 25vh;
   border-radius: 0.625rem;
}
.box1left2{
height: 50vh;
margin-top: 2vh;
background: #fff;
padding: 0.9375rem;
 border-radius: 0.625rem;
}

.box2center{
height: 50vh;
 border-radius: 0.625rem;
 padding: 0.9375rem;

background: #fff;
  width: 100%;
  overflow: hidden;
  overflow-y: auto;

}



/* 文本样式 */
.text {
  font-size: 1.125rem;
  font-weight: 500;
  color: #333;
  margin-bottom: 0.625rem;
}
/* 固定尺寸的视频播放器 */
.fixed-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain; /* 保持原始比例，完整显示视频 */
}
.video-container {
  width: 100%; /* 调整宽度为80%，或者其他更大的值 */
  height: 0;
  padding-bottom: 45%; /* 如果需要更大的高度，适当减少这个比例 */
  position: relative;
  background: #000;
  margin-bottom: 15px;
}
.active-type {
  border: 2px solid #409eff !important;
  background-color: #f5f9ff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}
/* 复选框样式 */
.check-box {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  margin-left: 10px;
  cursor: pointer;
  text-align: center;
  line-height: 20px;
}

.check-box.checked {
  background-color: #67c23a;
  color: white;
}
.el-row {
  margin-bottom: 10px;
}
.el-col {
  padding-right: 10px;
}

/* 改进后的勾勾按钮，放到选项框外面 */
.check-box {
  position: absolute;
  top: 50%;
  left: 100%; /* 使勾选框出现在输入框的右侧 */
  margin-left: 10px; /* 添加适当的间距 */
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  border: 2px solid #409EFF;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 10; /* 确保勾选框在前面 */
}

.check-box.checked {
  background-color: #409EFF;
  border-color: #409EFF;
}

.check-box .check-icon {
  width: 10px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}
  /* 单个题目表单 */
.current-question {
  padding: 35px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
}

/* 当前激活的题目 */
.active-form {
  border: 2px solid #409eff;
}
.stand{
 
width: 100%;

margin-top: 20px;
  border: 1px solid rgba(240, 240, 240, 1);
  /* background: rgba(237, 243, 246, 1); */

}
/* 可以添加一些自定义样式 */
.video-container {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%; /* 16:9 比例 */
}

.fixed-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* 滑块验证对话框样式 */
.slider-verify-dialog .el-dialog__body {
  padding: 20px;
}
</style>